import type {CheckLeadSimilaritySearchInput} from "./check-lead-similarity.schema";

import {checkLeadSimilarity} from "@project/sdk/sales";
import {CheckLeadSimilarityResponse} from "@project/sdk/sales/zod";
import {queryOptions} from "@tanstack/react-query";

import {queryPolicyDefaults} from "../../../../../shared/query/query-policies";
import {leadKeys} from "../../../lead-keys";

import {checkLeadSimilaritySearchSchema} from "./check-lead-similarity.schema";

export function checkLeadSimilarityQueryOptions(rawInput: CheckLeadSimilaritySearchInput) {
  const search = checkLeadSimilaritySearchSchema.parse(rawInput);

  return queryOptions({
    ...queryPolicyDefaults.warm,
    queryKey: leadKeys.similarity(search),
    queryFn: async ({signal}) =>
      CheckLeadSimilarityResponse.parse(await checkLeadSimilarity(search, {signal})),
  });
}
